export default __webpack_public_path__ + "static/media/arrow-down-gray.331cd64b.svg";